import {
  useState,
  useEffect,
  useCallback,
  useMemo,
  SetStateAction,
  useRef
} from 'react';

import FormProvider from 'src/minimal-components/hook-form/form-provider';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Dialog, {DialogProps} from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Iconify from 'src/components/iconify';
import {Upload} from 'src/components/upload';
import uuidv4 from 'src/utils/uuidv4';
import Checkbox from '@mui/material/Checkbox';
import {
  Paper,
  Typography,
  Grid,
  Tabs,
  Tab,
  Card,
  FormControl,
  InputLabel,
  MenuItem,
  Select
} from '@mui/material';
import {Box, display, maxHeight, useTheme} from '@mui/system';
import {Controller, useForm} from 'react-hook-form';
import {yupResolver} from '@hookform/resolvers/yup';
import * as yup from 'yup';
import {DesktopDatePicker} from '@mui/x-date-pickers';
import {LocalizationProvider} from '@mui/x-date-pickers/LocalizationProvider';
import {AdapterDateFns} from '@mui/x-date-pickers/AdapterDateFns';
import LockProperties from './LockProperties';
import SnackBarConfig from '@components/snackbar/SnackbarConfig';
import {
  getSearchForm,
  getSearchResultsData
} from '@shared/services/service-handlers/PrivateService';
import {getErrorMessage} from '@shared/utils/ErrorUtils';
import {useSnackbar} from 'notistack';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {useAppContext} from '@context/AppContext';
import {useParams, useLocation} from 'react-router-dom';
import {BASE_MENU_ITEM} from 'src/routes/BaseRoute';
import {LoadingScreen} from 'src/minimal-components/loading-screen';
import SelectInput from '@components/form/select-input/SelectInput';
import FormConstants from '@shared/constants/FormConstants';
import {FormControlDiv} from '../../module-search-filter/ModuleSearchFilterStyle';
import EncryptUtils from 'src/utils/EncryptUtils';
// ----------------------------------------------------------------------
interface FileToUpload {
  ids: string;
  fileData: string;
  fileName: string;
  fileType: string;
  fileError: string;
}
interface FilterStateProps {
  formError: string;
  uiFields: Array<any>;
  sourceType: string;
  dropDownValues: Array<any>;
  dropdownLoader: boolean;
  selectionListLoader: boolean;
  patientForm: boolean;
  accessForm: boolean;
  userForm: boolean;
  selectionListData: any;
  legacyAppValue: string;
  selections: string[];
  selectSubModuleValue: string;
  searchLoader: boolean;
  moduleAcessSelected: string;
}

interface WrittenData {
  id: string;
  title: string;
  description: string;
  date: string;
  isFavorited: boolean;
  attachmentName?: FileToUpload[];
}
interface Props extends DialogProps {
  title?: string;
  //
  // eslint-disable-next-line react/boolean-prop-naming
  onCreate?: boolean;
  //
  folderName?: WrittenData;
  onChangeFolderName?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  //
  // eslint-disable-next-line react/boolean-prop-naming
  open: boolean;
  onClose: VoidFunction;
  onSave?: (vals: WrittenData[]) => void; // Add your save logic here
  onEditSave?: (vals: WrittenData) => void; // Add your save logic here
}
interface BasicInfo {
  name: string;
  Duration: number;
  Description: string;
}
export default function ImportModule({
  title = 'Import',
  open,
  onClose,
  onCreate,
  folderName,
  onChangeFolderName,
  onSave,
  onEditSave,
  ...other
}: Props) {
  const {t} = useTranslation();
  const {enqueueSnackbar} = useSnackbar();
  const [isloaded, setIsLoaded] = useState(false);
  const [basicInfo, setBasicInfo] = useState<BasicInfo>({
    name: '',
    Duration: 0,
    Description: ''
  });
  const {
    appState: {applicationName}
  } = useAppContext();
  const [state, setState] = useState<FilterStateProps>({
    formError: '',
    sourceType: '',
    uiFields: [],
    dropDownValues: [],
    userForm: false,
    accessForm: false,
    patientForm: false,
    dropdownLoader: false,
    selectionListData: [],
    legacyAppValue: '',
    selections: [],
    selectionListLoader: false,
    selectSubModuleValue: '',
    searchLoader: false,
    moduleAcessSelected: ''
  });
  const {
    formError,
    uiFields,
    dropDownValues,
    userForm,
    accessForm,
    patientForm,
    dropdownLoader,
    selectionListData,
    legacyAppValue,
    selections,
    selectionListLoader,
    selectSubModuleValue,
    searchLoader,
    moduleAcessSelected,
    sourceType
  } = state;
  // const theme = useTheme();
  // const params: any = useParams();
  // const location = useLocation();
  // const sourceSystemOptions = useRef();
  // const menuItem = new URLSearchParams(location?.search).get(BASE_MENU_ITEM);
  // const menuItem1 = new URLSearchParams(location.search).get('section');
  // const menuItem2 = new URLSearchParams(location?.search).get('subsection');
  // const uniqueid = new URLSearchParams(location?.search).get('uniqueId');
  const [loader, setLoader] = React.useState(false);
  const [uiFieldsData, setUIFieldsData]: any = useState({});
  const methods = useForm({});
  const {
    control,
    handleSubmit,
    reset,
    setValue,
    formState: {errors, isSubmitting}
  } = methods;
  const init = async () => {
    try {
      setLoader(true);
      const res = await getSearchForm(
        applicationName,
        'module',
        'ModuleImport'
      );
      setUIFieldsData(res.searchForm);
      if (res.searchForm.sub_sections[0].fields.source_type.defaultSelect) {
        setState((prevState: FilterStateProps) => ({
          ...prevState,
          sourceType: res.searchForm.sub_sections[0].fields.source_type.defaultSelect
        }));
        setValue(
          'source_type',
          res.searchForm.sub_sections[0].fields.source_type.defaultSelect
        );
      }
      setLoader(false);
    } catch (e) {
      const errMessage = getErrorMessage(e);
      enqueueSnackbar(errMessage, SnackBarConfig.getError());
      setLoader(false);
    }
  };

  React.useEffect(() => {
    if (open) {
      init();
    }
  }, [open]);

  // const setInitialValues = () => {
  //   setValue(FormConstants.LEGACY_APP.LEGACY_APP, defaultLegacyAppValue);
  // };
  // useEffect(() => {
  //   setInitialValues();
  // }, []);
  const generateOptionsList = (fields: any, data: any) => {
    const optionsList: any = [];

    fields.map((fieldObj: any) => {
      if (fieldObj?.generate_options) {
        data?.map((dataObj: any) => {
          const dynamicKey = Object.keys(dataObj)[0]; // Get the first key dynamically
          const dynamicValue = dataObj[dynamicKey]; // Access the value for the dynamic key
          optionsList.push({
            label: dynamicValue,
            value: dynamicValue
          });
        });
      }
    });

    return optionsList;
  };

  const handleLegacyAppChange = async (
    event: any,
    name: string,
    sqldatafield?: any
  ) => {
    const {sql_data} = sqldatafield;
    // const {sql, variables, schema} = sql_data;
    const jsonData = uiFieldsData.sub_sections[0];
    const filedData = jsonData[sourceType];
    // sqlData.sql = uiFieldsData?.folderList_dropdown_sql?.replaceAll(
    //   '###LegacyApp',
    //   `'${legacyApp}'`
    // );
    try {
      setIsLoaded(true);
      const data: any = {
        sql_data: sql_data,
        isImportFiles: true
      };
      const encryptRequestData = EncryptUtils.encryptedData(data);
      const result = await getSearchResultsData(applicationName, 'LMS', {
        tk: encryptRequestData
      });
      setIsLoaded(false);
      const new_options = generateOptionsList(
        [{generate_options: true}],
        result?.data
      );
      return new_options;
    } catch (e) {
      const errMessage = getErrorMessage(e);
      enqueueSnackbar(errMessage, SnackBarConfig.getError());
      setIsLoaded(false);
    }
  };

  // useEffect(() => {
  //   if (sourceType) {
  //     handleLegacyAppChange(sourceType);
  //   }
  // }, [sourceType]);

  const handleDropdownChange = async (event: any, name: string) => {
    setState((prevState: FilterStateProps) => ({
      ...prevState,
      sourceType: event.target.value
    }));
  };
  const renderthedata = (data: any) => {
    const subSection = data[sourceType];

    if (!subSection || !subSection.fields) {
      return <p>No fields found for the selected source type</p>;
    }
    return Object.keys(subSection.fields).map((fieldKey, index) => {
      const field = subSection.fields[fieldKey];

      // Render a field based on its type
      switch (field.type) {
        case 'select':
          return (
            <Grid item xs={12} md={8} key={fieldKey}>
              <FormControl fullWidth>
                <InputLabel>{field.heading[0]}</InputLabel>
                <Select placeholder={field.placeholder[0]} defaultValue="">
                  {field.drop_down_options &&
                    field.drop_down_options[0][fieldKey]?.map((option: any) => (
                      <MenuItem value={option.value} key={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Grid>
          );
        case 'selects':
          return (
            <Grid item xs={12} md={12} key={index}>
              <Controller
                name={fieldKey}
                control={control}
                defaultValue={field?.default}
                render={({field: {value, onChange}}) => (
                  <FormControlDiv>
                    <SelectInput
                      sx={{maxWidth: '30vh', maxHeight: '30vh'}}
                      enableDefaultOption
                      options={[]}
                      label={
                        uiFieldsData.sub_sections[0].fields.source_type.heading
                      }
                      placeholder={
                        uiFieldsData.sub_sections[0].fields.source_type
                          .placeholder
                      }
                      name={fieldKey}
                      value={value || ''}
                      fullWidth
                      onOpenCallback={(event: any) =>
                        handleLegacyAppChange(event, fieldKey, field)
                      }
                      onChange={(event: any) => {
                        onChange(event);
                        setState(prevState => ({
                          ...prevState,
                          formError: ''
                        }));
                      }}
                      optionValueKey={'value'}
                      optionLabelKey={'value'}
                      fetchOptionsFromOnOpenTrigger
                      MenuProps={{
                        PaperProps: {
                          style: {
                            maxHeight: '30vh', // Set dropdown max height
                            overflowY: 'auto', // Enable scrolling
                          },
                        },
                      }}
                    />
                  </FormControlDiv>
                )}
              />
            </Grid>
          );
        case 'text':
          return (
            <Grid item xs={12} md={6} key={fieldKey}>
              <TextField
                fullWidth
                label={field.heading[0]}
                placeholder={field.placeholder[0]}
                variant="outlined"
              />
            </Grid>
          );

        default:
          return (
            <Grid item xs={12} key={fieldKey}>
              <p>Unsupported field type: {field.type}</p>
            </Grid>
          );
      }
    });
  };
  // const sourceSelection = () => {
  //   return (
  //     <Grid item xs={12} md={12} key="source_type">
  //       <Controller
  //         name="source_type"
  //         control={control}
  //         defaultValue="Files"
  //         render={({field: {value, onChange}}) => (
  //           <FormControlDiv>
  //             <SelectInput
  //               enableDefaultOption
  //               options={
  //                 uiFieldsData.sub_sections[0].fields.source_type
  //                   .drop_down_options[0].source_type
  //               }
  //               label={uiFieldsData.sub_sections[0].fields.source_type.heading}
  //               placeholder={
  //                 uiFieldsData.sub_sections[0].fields.source_type.placeholder
  //               }
  //               name="source_type"
  //               value={value || ''}
  //               fullWidth
  //               onChange={(event: any) => {
  //                 onChange(event);
  //                 setState(prevState => ({
  //                   ...prevState,
  //                   formError: ''
  //                 }));
  //                 handleDropdownChange(event, 'source_type');
  //               }}
  //               optionValueKey={'value'}
  //               optionLabelKey={'value'}
  //             />
  //           </FormControlDiv>
  //         )}
  //       />
  //     </Grid>
  //   );
  // };
  // const createValidationSchema = (questions: BasicInfo) =>
  //   yup.object().shape({
  //     name: yup.string().required('Name is required'),
  //     Duration: yup
  //       .number()
  //       // .required('Duration is required')
  //       // .positive('Duration must be a positive number')
  //       ,
  //     Description: yup.string()
  //     // .required('Description is required')
  //   });

  // // Memoize validation schema
  // const validationSchema = useMemo(
  //   () => createValidationSchema(basicInfo),
  //   [basicInfo]
  // );

  // Hook form methods

  // Handle form submission

  const onSubmit = (data: any) => {
    console.log('Form Data: ', data);
  };

  return (
    <Dialog fullWidth maxWidth="lg" open={open} onClose={onClose} {...other}>
      {!loader && uiFieldsData && Object.keys(uiFieldsData).length ? (
        <>
          <DialogTitle sx={{p: theme => theme.spacing(3, 3, 2, 3)}}>
            <h3 style={{marginRight: '-0.5vh'}}> {uiFieldsData.heading}</h3>

            <Stack
              direction="row"
              alignItems="center"
              sx={{
                top: 8,
                right: 8,
                position: 'absolute'
              }}>
              <IconButton aria-label="close" onClick={onClose}>
                <CloseIcon />
              </IconButton>
            </Stack>
          </DialogTitle>
          <DialogContent dividers sx={{pt: 1, pb: 0, border: 'none'}}>
            <Card
              elevation={3}
              sx={{
                p: 3,
                minHeight: '70vh',
                border: '1px solid #e0e0e0', // Add border to all sides
                marginBottom: 3 // Add margin at the bottom
              }}>
              <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
                <Grid container spacing={2} sx={{minHeight: '68vh'}}>
                  {/* Tabs and Content */}

                  {/* Tab Content */}
                  <Grid item xs={12} md={12}>
                    <Grid container spacing={2}>
                      {/* Name Field */}
                      <Grid item xs={12} md={12} key="source_type">
                        <Controller
                          name="source_type"
                          control={control}
                          defaultValue="Files"
                          render={({field: {value, onChange}}) => (
                            <FormControlDiv>
                              <SelectInput
                                enableDefaultOption
                                options={
                                  uiFieldsData.sub_sections[0].fields
                                    .source_type.drop_down_options[0]
                                    .source_type
                                }
                                label={
                                  uiFieldsData.sub_sections[0].fields
                                    .source_type.heading
                                }
                                placeholder={
                                  uiFieldsData.sub_sections[0].fields
                                    .source_type.placeholder
                                }
                                name="source_type"
                                value={value || ''}
                                fullWidth
                                onChange={(event: any) => {
                                  onChange(event);
                                  setState(prevState => ({
                                    ...prevState,
                                    formError: ''
                                  }));
                                  handleDropdownChange(event, 'source_type');
                                }}
                                optionValueKey={'value'}
                                optionLabelKey={'value'}
                                MenuProps={{
                                  PaperProps: {
                                    style: {
                                      maxHeight: '30vh', // Set dropdown max height
                                      overflowY: 'auto', // Enable scrolling
                                    },
                                  },
                                }}
                              />
                            </FormControlDiv>
                          )}
                        />
                      </Grid>
                      {/* {sourceSelection()} */}
                      {renderthedata(uiFieldsData.sub_sections[0])}
                      {/* {renderthedata(uiFieldsData.sub_sections[0])} */}
                      {/* Save Button */}
                      <Box
                        sx={{
                          position: 'absolute',
                          bottom: '3vh',
                          left: '2vh'
                        }}>
                        <Button
                          variant="contained"
                          color="primary"
                          type="submit">
                          Save
                        </Button>
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>
              </FormProvider>
            </Card>
          </DialogContent>
        </>
      ) : (
        <Stack
          display={'flex'}
          justifyContent={'center'}
          alignItems={'center'}
          minHeight={'80vh'}>
          <LoadingScreen />
        </Stack>
      )}
    </Dialog>
  );
}
